import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuelidate from 'vuelidate'
import moment from "moment";
import VCalendar from 'v-calendar';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import store from "./store";
import axios from "axios";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import SortedTablePlugin from "vue-sorted-table";


window.moment = moment;
Vue.component('DatePicker', DatePicker);
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueToast)
Vue.use(SortedTablePlugin);
Vue.use(VCalendar, {
  componentPrefix: 'vc', 
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  render: h => h(App),
 
}).$mount('#app')
